// import * as boltSpacingSizes from '@bolt/core/data/spacing-sizes.js';

// export const spacingSizes = boltSpacingSizes.boltSpacingSizes;
// @todo Grab the actual data from `./build/data/spacing/sizes.bolt.json`
export const spacingSizes = {
  xxsmall: '0.25rem',
  xsmall: '0.5rem',
  small: '1rem',
  medium: '2rem',
  large: '4rem',
  xlarge: '8rem',
  xxlarge: '16rem',
};
